export const accountTypes = [
    ["Checking", "C"],
    ["Savings", "S"]
];